import { Logo } from "@/components/common";

export default function Legal({ kind }) {
  const terms = kind === "terms";
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <Logo />
      <h1 className="font-display text-3xl font-bold text-white mt-6">{terms ? "Terms of Service" : "Privacy Policy"}</h1>
      <div className="mt-6 space-y-4 text-slate-300 text-sm leading-relaxed" data-testid={`legal-${kind}`}>
        {terms ? (
          <>
            <p>Welcome to PokeDrop. By using this site you agree to these terms. PokeDrop is a community storefront for Pokémon card collectors offering paid drops, free giveaways, and a one-of-one shop.</p>
            <p><b className="text-white">Drops & Giveaways.</b> A drop is a seat-based prize draw. You purchase numbered seats; when all seats are claimed the host runs a random draw and winners are selected. Free giveaways cost nothing to enter. Referral giveaways award entries when invited friends sign up while the giveaway is open.</p>
            <p><b className="text-white">Fair draws.</b> Winners are selected using RANDOM.ORG's true random number generator.</p>
            <p><b className="text-white">Payments.</b> Payments are processed securely through Stripe. All sales are final except where a drop is cancelled by the host before the draw, in which case paid entries are refunded to your store-credit wallet.</p>
            <p><b className="text-white">Conduct.</b> Be respectful in community chat. The host may mute users who violate community standards.</p>
            <p><b className="text-white">Accounts.</b> You may delete your account at any time from your account page.</p>
          </>
        ) : (
          <>
            <p>Your privacy matters. This policy explains what we collect and how we use it.</p>
            <p><b className="text-white">What we collect.</b> Account email, display name, order and shipping details you provide, and gameplay data (seats, entries, wallet ledger).</p>
            <p><b className="text-white">Shipping addresses.</b> Addresses you provide for winning or purchased items are shared only with the host for fulfillment and are never shown to other users.</p>
            <p><b className="text-white">Payments.</b> Card details are handled entirely by Stripe; we never see or store your card number.</p>
            <p><b className="text-white">Referrals.</b> Your unique invite code links new signups to you for giveaway entries.</p>
            <p><b className="text-white">Your control.</b> You can delete your account and associated data at any time from the account page.</p>
          </>
        )}
      </div>
    </div>
  );
}
